import {
  Component,
  ElementRef,
  ViewChild,
  signal,
  AfterViewInit,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-radio-player',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio-player.component.html',
  styleUrls: ['./radio-player.component.scss'],
})
export class RadioPlayerComponent implements AfterViewInit {
  isPage = input<boolean>(false);

  // Cambia esto por la URL real del stream
  private readonly STREAM_URL = 'https://streamingcwsradio30.com:8344/stream';

  @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;

  isPlaying = signal(false);
  isMini = signal(false);
  volume = signal(70);
  trackTitle = signal('');

  ngAfterViewInit(): void {
    // preload="none": el src se asigna en runtime, no en el template,
    // para no disparar la carga del stream antes de tiempo
    this.audioRef.nativeElement.src = this.STREAM_URL;
    this.setVolume(this.volume());
  }

  togglePlay(): void {
    const audio = this.audioRef.nativeElement;

    if (!this.isPlaying()) {
      audio.play().catch(() => {
        console.warn('No se pudo reproducir el stream. Verifica STREAM_URL.');
      });
    } else {
      audio.pause();
    }
  }

  onPlay(): void {
    this.isPlaying.set(true);
  }

  onPause(): void {
    this.isPlaying.set(false);
  }

  onVolumeInput(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    this.setVolume(value);
  }

  toggleMini(): void {
    this.isMini.update((v) => !v);
  }

  private setVolume(value: number): void {
    this.volume.set(value);
    this.audioRef.nativeElement.volume = value / 100;
  }
}
